import { AfterContentInit, OnDestroy, OnInit, ViewChild, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { PlycaDataService } from '../../../services/plyca.service';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { Configuration } from '../../conf/app.constants';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import { catchError, finalize, tap } from 'rxjs/operators';
import { FormConfig } from '../../components/forms/form.objects';
import { AntecedentLineDTO, ContractDTO, ContractModificationDTO } from '../../api/plyca-dtos-v2';
import { getSimpleIdentifierFromString } from '../../api/plyca-dtos';
import { TranslateService } from '@ngx-translate/core';
import { HelpService } from '../../components/common/help/help.service';
import { AppConfiguration } from '../../conf/app.configuration';
import { UserService } from '../../user.service';
import { Observable, forkJoin, of } from 'rxjs';


export class AntecedentsDTO {
  coefficient: number;
  withPriceRevision = false;
  contractModificationAntecedents: AntecedentLineDTO[];
  contractAntecedents: AntecedentLineDTO[];
  filterContractModificationAntecedents: AntecedentLineDTO[];
  filterContractAntecedents: AntecedentLineDTO[];
  rvpAntecedents: AntecedentLineDTO[];
}

@Component({
  selector: 'antecedentAYMADComponent',
  templateUrl: 'antecedentAYMAD.template.html',
  providers: [DialogService]
})


export class AntecedentAYMADComponent extends BaseComponent implements AfterContentInit, OnDestroy, OnInit {
  loaded = false;
  antecedents: AntecedentsDTO;

  @ViewChild('formPlycaRef') formPlycaRef1: formPlycaComponent;
  formConfig1: FormConfig;

  windowHash: string;
  OptionsWindowHash: string;
  contractModification: ContractModificationDTO;
  contract: ContractDTO;
  dossierId: string;
  antecedentMode: string;
  contractModificationDivision: string;
  contractDivision: string;
  frameworkAgreement: boolean;

  constructor(
    public plycaService: PlycaDataService,
    public configuration: Configuration,
    public helpService: HelpService,
    public uiService: UIService,
    public userService: UserService,
    public waitService: WaitLoadingService,
    private headerActionsService: HeaderActionsService,
    public dialogService: DialogService,
    private plycaErrorHandler: PlycaErrorHandler,
    public translateService: TranslateService,
    public dialogConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    protected route: ActivatedRoute,
    protected appConfig: AppConfiguration
  ) {
    super();

    // this.subscribe(this.helpService.showContextHelpObservable(HelpType.UNITPRICES_LIST));
    if (dialogConfig['context'] && dialogConfig['context']['contractModification']) {
      this.contractModification = dialogConfig['context']['contractModification'];
      this.contract = this.contractModification?.contract;
      this.dossierId = dialogConfig['context']['dossierId'];
      this.antecedentMode = dialogConfig['context']['antecedentMode'];
      this.contractDivision = this.contractModification?.contract !== undefined ?
        getSimpleIdentifierFromString(this.contractModification?.contract?.division.identifier) : (
          this.contractModification?.division?.parent?.identifier !== undefined ?
            getSimpleIdentifierFromString(this.contractModification.division.parent.identifier) : '');
      this.contractModificationDivision = this.contractModification.division !== undefined &&
        this.contractModification.division.identifier !== undefined ?
        getSimpleIdentifierFromString(this.contractModification.division.identifier) : '';
      if (this.contractModification?.procurementProjectInfo !== undefined &&
        this.contractModification.procurementProjectInfo.complementarySystem !== undefined &&
        this.contractModification.procurementProjectInfo.complementarySystem.identifier !== undefined) {
        this.frameworkAgreement =
          this.contractModification.procurementProjectInfo.complementarySystem.identifier === 'AM<>SISTCOMPLEMENTARIO';
      } else {
        this.frameworkAgreement = false;
      }
    }
    this.dtoToModel();

  }

  ngOnInit(): void {
    this.windowHash = generateRandomIdentifier();
    this.OptionsWindowHash = generateRandomIdentifier();
  }

  dtoToModel() {
    this.antecedents = new AntecedentsDTO();
    this.antecedents.withPriceRevision = false;
    this.subscribe(this.createFormConfig1(),
      (form1: FormConfig) => {
        this.formConfig1 = form1;
        this.formConfig1.functions.push({
          identifier: 'setShowPriceRevision',
          fn: this.setShowPriceRevision.bind(this)
        });
        this.formConfig1.functions.push({
          identifier: 'isVisiblePriceRevision',
          fn: this.isVisiblePriceRevision.bind(this)
        });
      });
  }



  private createFormConfig1(): Observable<FormConfig> {

    return of(new FormConfig(undefined,
      'antecedents/antecedentFilterISettings.json',
      this.antecedents
    ));
  }

  ngAfterContentInit(): void {
    this.generalActions();
    this.loadData();
  }

  generalActions() {
    /*this.subscribe(this.headerActionsService.addWindowAction(
      'General.close',
      'fas fa-times',
      'btn-outline-secondary',
      true, this.windowHash
    ), success => {
      this.ref.close();
    });*/
  }

  ngOnDestroy() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  loadQueries(): Observable<any> {
    let allQueriesObs = new Array<Observable<any>>();
    let obs: Observable<any>;

    /*this.waitService.startWaiting();
    this.loaded = false;*/
    let paramsContractModification = {
      'dossierId': this.dossierId,
      'contractDivision': this.contractDivision,
      'division': this.contractModificationDivision,
      'antecedentMode': 'contractModification'
    }
    let paramsContract = {
      'dossierId': this.dossierId,
      'contractDivision': this.contractDivision,
      'antecedentMode': 'contract'
    }
    let paramsRVP = {
      'dossierId': this.dossierId,
      'contractDivision': this.contractDivision,
      'antecedentMode': 'contractRVP'
    }

    // CONTRATO
    obs = this.plycaService.query<AntecedentLineDTO>(
      this.configuration.ANTECEDENT_SERVICE_URL, paramsContract
    ).pipe(
      tap(_contractAntecedentsLines => {
        if (_contractAntecedentsLines?.content) {
          console.log('ANTECEDENTES DEL CONTRATO ->', _contractAntecedentsLines);
          this.antecedents.contractAntecedents = _contractAntecedentsLines.content;
          this.antecedents.filterContractAntecedents = _contractAntecedentsLines.content;
          if (_contractAntecedentsLines.content[0].coefficient !== undefined) {
            let aux2 = _contractAntecedentsLines.content[0].coefficient.toFixed(8)
            this.antecedents.coefficient = parseFloat(aux2);
          }
          this.setShowPriceRevision();
        } else {
          this.antecedents.contractAntecedents = [];
        }
      }),
      catchError(err => {
        console.log('Error cargando los antecedentes del Contrato', err);
        return of({});
      })
    );
    allQueriesObs.push(obs);

    // RVP
    obs = this.plycaService.query<AntecedentLineDTO>(
      this.configuration.ANTECEDENT_SERVICE_URL, paramsRVP
    ).pipe(
      tap(_antecedentsRVP => {
        if (_antecedentsRVP?.content) {
          console.log('ANTECEDENTES RVP ->', _antecedentsRVP);
          this.antecedents.rvpAntecedents = _antecedentsRVP.content;
        } else {
          this.antecedents.rvpAntecedents = [];
        }
      }),
      catchError(err => {
        console.log('Error cargando los antecedentes del revisiones de precio', err);
        return of({});
      })
    );
    allQueriesObs.push(obs);

    // FI
    if (this.contractModificationDivision !== '') {
      obs = this.plycaService.query<AntecedentLineDTO>(
        this.configuration.ANTECEDENT_SERVICE_URL, paramsContractModification
      ).pipe(
        tap(_antecedentsLines => {
          if (_antecedentsLines?.content) {
          console.log('ANTECEDENTES DE LA INCIDENCIA ->', _antecedentsLines);
          this.antecedents.contractModificationAntecedents = _antecedentsLines.content;
          this.antecedents.filterContractModificationAntecedents = _antecedentsLines.content;
          } else {
            this.antecedents.contractModificationAntecedents = [];
          }
        }),
        catchError(err => {
          console.log('Error cargando los antecedentes del Contrato', err);
          return of({});
        })
      );
      allQueriesObs.push(obs);
    } else {
      this.antecedents.contractModificationAntecedents = [];
    }
    return forkJoin(allQueriesObs);
  }

  loadData() {
    this.waitService.startWaiting();
    this.loaded = false;
    this.subscribe(
      this.loadQueries().pipe(
        finalize(() => {
          // Finalización
          this.loaded = true;
          this.waitService.cancelWaiting();
        })
      ),
      () => {
        console.log('');
      }
    );
  }

  public _getSimpleIdentifierFromString(identifier) {
    return getSimpleIdentifierFromString(identifier);
  }


  public setShowPriceRevision(): void {
    if (this.antecedents !== undefined) {
      if (!this.antecedents.withPriceRevision) {
        // Eliminamos del vector de incidencias la RVP.
        if (this.antecedents.filterContractModificationAntecedents !== undefined) {
          this.antecedents.filterContractModificationAntecedents
            = this.antecedents.filterContractModificationAntecedents.filter(item => item.contractModificationIdentifier !== '000012');
        }
        if (this.antecedents.filterContractAntecedents !== undefined) {
          this.antecedents.filterContractAntecedents
            = this.antecedents.filterContractAntecedents.filter(item => item.contractModificationIdentifier !== '000012');
        }
      } else {
        this.antecedents.filterContractModificationAntecedents = this.antecedents.contractModificationAntecedents;
        this.antecedents.filterContractAntecedents = this.antecedents.contractAntecedents;
      }
    }
  }

  public isVisiblePriceRevision(): boolean {
    let visible = true;
    let isFrameworkAgremeent = this.frameworkAgreement;
    let rvpWithoutBudgetAntecedents = this.antecedents !== undefined
    && this.antecedents.rvpAntecedents !== undefined
    && this.antecedents.rvpAntecedents.length > 0;

    let rvpAntecedentes = this.antecedents.contractAntecedents.some(item => item.contractModificationIdentifier === '000012');


    visible = !isFrameworkAgremeent && (rvpWithoutBudgetAntecedents || rvpAntecedentes);
    return visible;
  }

}
